import React, { useContext, useEffect } from 'react';

import { AuthContext } from '../../../../context/AuthProvider';
import { useChallengeProgramsQuery } from '../../../../generated/graphqlModels';
import ClassComponent from '../../components/ClassComponent';
import ClassPage from '../Class';
import { Button, HStack, Text, VStack } from '@chakra-ui/react';
import Loader from '../../../../components/Loader';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Challenge = () => {
  const navigate = useNavigate();
  const user = useContext(AuthContext);
  const {t} = useTranslation()
  const { data, loading } = useChallengeProgramsQuery();

  const programs = user
    ? data?.programs.filter((p) => {
        const intersectionNamespaces = p.namespaces.filter((n) =>
          user.namespaces.includes(n),
        );
        return intersectionNamespaces.length > 0;
      }) || []
    : [];

  useEffect(() => {
    if (programs.length) {
      const program = programs[0]!;
      navigate(`/program/${program.id}/units/?challenge=true`, {
        replace: true,
      });
    }
  }, [programs]);

  if (loading) {
    return <Loader />;
  }

  if (programs.length) {
    const program = programs[0]!;
    return (
      <VStack align="start" gap="4" w="full">
        <Text as="h3" textStyle="h3">
          {t('teacherTrainingPage.teacherTraining')}
        </Text>
        <ClassComponent
          to={ClassPage.getRoute(program.id, 'units', `?challenge=true`)}
          {...program}
          name={program.name}
          enabled={true}
          sameHeight={false}
          showInfo={true}
        />
      </VStack>
    );
  }
  return (
    <HStack alignItems="center" justify="center" w="full" h="full">
      <Text fontSize="3xl">{t('teacherTrainingPage.comingSoon')}</Text>
    </HStack>
  );
};

export default Challenge;
